module.exports = __webpack_public_path__ + "img/alhayat_logo.711fc54.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/arabic/alhayat_logo.png
// module id = ./assets/img/media/arabic/alhayat_logo.png
// module chunks = 0 9 11 12